import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

import T from '../../../../SPRINTA/translate/T'

import PlaceHolder from '../../../atoms/PlaceHolder'
import { Container, Row, Col } from '../../../atoms/Grid'
import Link from '../../../atoms/Link'
import Button from '../../../../SPRINTA/atoms/Button'
import Valign from '../../../atoms/Valign'
import FontIcon from '../../../atoms/FontIcon'
import Carousel from '../../../third-party/SlickCarousel'



import style from './style.css'

export default class ListPrices extends Component {
    static propTypes = {
        token: PropTypes.string.isRequired
    }

    state = {
        attachments: null
    }

    componentWillMount() {
        axios.get(`event_attachments/attachments/${this.props.token}/0/30`)
        .then(resp => {
            this.setState({
                attachments: resp.result
            })
        })
    }

    render() {

        if(this.state.attachments !== null && this.state.attachments.length === 0) return <span />
        return (
            <Container style={{paddingTop: '60px', paddingBottom: '0px'}}>
                <Row>
                    <Col size={8}>
                        { this.state.attachments === null && (
                            <Row>
                                <Col size={4}>
                                    <PlaceHolder type='retangle'/>
                                </Col>
                                <Col size={4}>
                                    <PlaceHolder type='retangle'/>
                                </Col>
                                <Col size={4}>
                                    <PlaceHolder type='retangle'/>
                                </Col>
                            </Row>
                        )}

                        { this.state.attachments !== null && (
                            <div>
                                <div className={style.title}>{T.text('files')}</div>
                                <br />
                                <Carousel arrows={false}>
                                    {this.state.attachments.map(attachment => (
                                        <div key={attachment.id}>
                                            <Col style={{textAlign: 'center', paddingTop: '30px'}}>
                                                <FontIcon circle size={25} color='#f50' name='download'/>
                                                <div className={style.description}>
                                                    <Valign text='center'>
                                                        {attachment.attachment_title}
                                                    </Valign>
                                                </div>
                                                <Link target='_blank' rel="noopener" href={`${window.config.url_attachments}${attachment.attachment_uri}`}>
                                                    <Button inline theme='primary'>{T.txt('download')}</Button>
                                                </Link>
                                            </Col>
                                        </div>
                                    ))}
                                </Carousel>

                            </div>
                        )}

                        <hr style={{ border: 0, borderBottom: '1px solid #9b9797', marginTop: '60px'}} />
                    </Col>
                </Row>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/templates/Event/ListAttachments/index.js